const initialState = {
  editing: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'TOGGLE_PAYMENT_EDIT': {
      return {
        ...state,
        editing: !state.editing,
      };
    }
    case 'PAYMENT_UPDATED': {
      return {
        ...state,
        editing: false,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/PaymentDetails/PaymentDetails.reducer.js